// ⚙️ Environment
export const VERCEL_TOKEN = "V2SyEjkTInNisyrPxmry1kA8";

// 📄 General Links
export const PDF_FOR_ANTI_RAGGING =
  "https://www.cmr.edu.in/wp-content/uploads/2025/10/Anti-Ragging-2025.pdf";
export const CONTACT_LINK =
  "https://drive.google.com/file/d/1GWSn-MFbjxWlDfDm3VWLd8PmCx8lbOIm/";
export const CDOE_PDF =
  "https://www.cmr.edu.in/wp-content/uploads/2025/07/CMRU_SOM_6-Page-Flyer_Digital.pdf";
export const BA_COURSE_LINKS =
  "https://docs.google.com/document/d/1oWx-T4J0ECY0ep9nezAMWQCybQFJ4iba/";
export const MBA_BBA_COURSE_LINKS =
  "https://docs.google.com/document/d/1Ud4iOGH81T06sAWrnuA3Q18XKY0YcRq0c_rU4EkKtwg/";

// ====================
// 🎓 MBA STUDY MATERIALS
// ====================

// sem-I
export const MANAGERIAL_ECONOMICS_LINK =
  "https://drive.google.com/file/d/11v-YKMnGL2MztMEgycN8Wgaf8HHHQWNi/";
export const ACCOUNTING_FOR_MANAGERS =
  "https://drive.google.com/file/d/1AQIlFrw4QlrXy7NaP09KLMoaENRq6LhB/";
export const DYNAMICS_OF_HUMAN_BEHAVIOR =
  "https://drive.google.com/file/d/1usriC8Pczb9Qs7Yc-C1NcemjMcGdxWyH/";
export const DYNAMICS_OF_HUMAN_BEHAVIOR_VIDEO_1 =
  "https://youtu.be/QghwBBFWopI?si=q4CsDIFoACnGHbEZ";
export const DYNAMICS_OF_HUMAN_BEHAVIOR_VIDEO_2 =
  "https://youtu.be/FX7y8OerjlQ?si=aSCehZpruL7SPK21";
export const INFORMATION_SYSTEM_AND_BUSINESS_ANALYTICS =
  "https://drive.google.com/file/d/1vWK7LKG268aYoOAbdh2BLfjhfkjVce7F/";
export const MARKETING_MANAGEMENT =
  "https://drive.google.com/file/d/1l0RhxoFLfRV6vUsXYVqn9i9-OEupNNCF/";
export const MARKETING_MANAGEMENT_VIDEO_1 =
  "https://youtu.be/9PaSCcKct48?si=fFWEEa5-PmwHK9ex";
export const MARKETING_MANAGEMENT_VIDEO_2 =
  "https://youtu.be/4ZF1_l1V95E?si=70nylQxDRxhwyX-s";
export const BUSINESS_STATISTICS_WITH_R =
  "https://drive.google.com/file/d/1Kwounr9KPykIO-kUU-ZgDvLzAVynyvUp/";
export const HUMAN_RESOURCE_MANAGEMENT =
  "https://drive.google.com/file/d/1u8H19TnSuWfYZcpDOvjaloXOebC6Cz9e/";
export const HUMAN_RESOURCE_MANAGEMENT_VIDEO =
  "https://youtu.be/FX7y8OerjlQ?si=-QddH5ZEvMKmlPYI";

// sem-II
export const INTERNATIONAL_BUSINESS_MANAGEMENT =
  "https://drive.google.com/file/d/1zRYMjtZygX68JVANFpKteYQ2uPjA8vxl/";
export const BUSINESS_RESEARCH_METHODS =
  "https://drive.google.com/file/d/1wyVaZ1n0sgihQ9Ioh4AOKQUqnHiZXL1k/";
export const FINANCIAL_MANAGEMENT_MBA =
  "https://drive.google.com/file/d/1J-u8172mgMUNxMieLiCQ0FI69bLJxu0i/";
export const OPERATIONS_RESEARCH_FOR_MANAGERS =
  "https://drive.google.com/file/d/1UdZX_iG2kMRf7CWI7AFbq0HYVWCtGTDz/";
export const DIGITAL_INNOVATION_AND_TRANSFORMATION_VIDEO =
  "https://youtu.be/cD8HIzClO8I?si=PFjDeusx251ZeTQx";
export const DIGITAL_MARKETING_VIDEO =
  "https://youtu.be/cD8HIzClO8I?si=PFjDeusx251ZeTQx";
export const EMPLOYEE_RELATIONSHIP_MANAGEMENT_VIDEO =
  "https://youtu.be/h0lHU6MQbEQ?si=5tSizN1fcFvDRFXa";
export const COMPETENCY_MAPPING_VIDEO =
  "https://youtu.be/QghwBBFWopI?si=YP4F-nAZZMS6zJCV";
export const STRATEGIC_ANALYSIS_AND_MANAGEMENT_VIDEO =
  "https://youtu.be/EEXwggKhM54?si=nWj7bE4bBzfqOYV0";
export const LEGAL_ENVIRONMENT_OF_BUSINESS_VIDEO =
  "https://youtu.be/ruU3yLRkvOE?si=2426T1VHerIYDRQP";

// sem-III
export const STRATEGIC_ANALYSIS_AND_MANAGEMENT =
  "https://drive.google.com/file/d/1eHsZAncU-eXZY3qxgGQWQf_ZlPh1vBOS/";
export const OPERATIONS_MANAGEMENT_MBA =
  "https://drive.google.com/file/d/1CgikTczkMt5lO0g7UO32Vf1UInYkr_H-/";

// sem-IV
export const LEGAL_ENVIRONMENT_OF_BUSINESS =
  "https://drive.google.com/file/d/1JpL86SRXtp6Nk6g9rPfdP7nsYfGtsaaR/";
export const LEADERSHIP_AND_CAPACITY_BUILDING =
  "https://drive.google.com/file/d/1x9QOBSSxQ3UHnACL2fxlF0HJkPn5wEeJ/";
export const TOTAL_QUALITY_MANAGEMENT =
  "https://drive.google.com/file/d/1pMO21d5RQ0KkNkGEbqozc5UtmGxYKFO_/";
export const TECHNOLOGY_MANAGEMENT =
  "https://drive.google.com/file/d/1BjuBmNxwqPLrh_RuSGb-7eILp94-4-Yq/";

// ====================
// 🎓 BBA STUDY MATERIALS
// ====================

// sem-I
export const FINANCIAL_ACCOUNTING =
  "https://drive.google.com/file/d/1VQHi_Lig-kOrk3UIUG7AFxxRUGqBT3B0/";
export const BUSINESS_AND_TECHNOLOGY =
  "https://drive.google.com/file/d/1aj6UDExfrjp7Q5REIR2e_ilTOIXIMvkH/";
export const BUSINESS_ECONOMICS =
  "https://drive.google.com/file/d/1HdU02TyPvd7_BksuxrtOreesOarZKnwf/";
export const BUSINESS_MATHEMATICS =
  "https://drive.google.com/file/d/1efl2qQAmXxT9Ld0SvxG4Ru5dudZfDyWd/";

// sem-II
export const PRINCIPLES_AND_PRACTICES_OF_MANAGEMENT =
  "https://drive.google.com/file/d/1GqTnwU4evqay9XBH_zI4V73BFxmotVkS/";
export const MACRO_ECONOMICS =
  "https://drive.google.com/file/d/14N92HmLcdxmB7WBP6nBDTPRT8c09Ibh7/";
export const CORPORATE_BUSINESS_LAW =
  "https://drive.google.com/file/d/16kIYtfit-4Lg9CnF6iGEzMiZA5ucyTJi/";
export const BUSINESS_STATISTICS_WITH_ADVANCED_EXCEL =
  "https://drive.google.com/file/d/1uXvy2_BW6Wh3hOZ-SPise_yFmeN_N6F9/";

// sem-III
export const CORPORATE_ACCOUNTING =
  "https://drive.google.com/file/d/14Gy_XbiuCd-j7_TCLza_SliZUiMW51Qe/";
export const HUMAN_RESOURCE_MANAGEMENT_BBA =
  "https://drive.google.com/file/d/1poFPJdZMDJHTPAYsaE3zRwRhQbw87NBT/";
export const MARKETING_MANAGEMENT_BBA =
  "https://drive.google.com/file/d/1Ohn0V-mTcBQXVFLCTHI_dZmdP_mJvWG7/";
export const OPERATIONS_MANAGEMENT_BBA =
  "https://drive.google.com/file/d/12ZvPdnIMXuMBWyTijbnuB4L7YHdCVlbb/";

// sem-IV
export const FINANCIAL_MANAGEMENT_BBA =
  "https://drive.google.com/file/d/1dRIBf2xgQH4TgL9-FMxKrU6XYedmu7e_/";
export const BUSINESS_RESEARCH_METHODS_BBA =
  "https://drive.google.com/file/d/10rBG33kOOrSq2fJx_XsHVmEy42gztFr7/";
export const ORGANISATIONAL_BEHAVIOR =
  "https://drive.google.com/file/d/16J6oYzKUM96ckjyCbGzyG83X1fyMOtNE/";

// sem-V
export const COST_MANAGEMENT_ACCOUNTING =
  "https://drive.google.com/file/d/1_IJXsdbGPCFzb1ZYq7R-fQi4axLaHEHV/";
export const OPERATIONS_RESEARCH =
  "https://drive.google.com/file/d/1rYirGF6GOin4HJlZLLCHmBAJXbnSkmLy/";
export const DIRECT_TAXATION =
  "https://drive.google.com/file/d/1accCSrTJFNpDbMX63OBuisptW9KGwwmS/";
export const STRATEGIC_MANAGEMENT =
  "https://drive.google.com/file/d/1hfzFaQ25cvFdXPc16Uw1IqtOb0hIAI2H/";

// sem-VI
export const ENTREPRENEURSHIP_DEVELOPMENT =
  "https://drive.google.com/file/d/1vBeP9P2fEx4TBdXXvR_MId0f_0LpcBzP/";

// ====================
// 🎓 BACHELOR OF ARTS (BA)
// ====================

// I SEMESTER
export const ANCIENT_INDIAN_HISTORY =
  "https://drive.google.com/file/d/16NYQu8HaBK02hGinYj22VOIh3WMsq9Jc/";
export const BASIC_CONCEPTS_IN_POLITICAL_SCIENCE =
  "https://drive.google.com/file/d/1SNl9zdC6v26SSw02Ajelvh7uOEGEFgn9/";
export const FOUNDATIONS_OF_COMMUNICATION =
  "https://drive.google.com/file/d/1dVHRJHA5fxgq29n9r9i0mzFM--VRsEuT/";
export const SOCIOLOGY_AN_INTRODUCTION =
  "https://drive.google.com/file/d/1MqyGrS815peP1dekxT7F12yeCsKSN9OV/";
export const BASICS_OF_TOURISM =
  "https://drive.google.com/file/d/11P3JryAauYQzM3LYsev72djHuAwqeaxU/";
export const DIGITAL_MEDIA_LITERACY =
  "https://drive.google.com/file/d/1_SAjVJfmRL0WCHbWCsVu4VDBGKu76tx3/";
export const COMPUTER_APPLICATION =
  "https://drive.google.com/file/d/1_z1vtZ2PlL8L6e3sRvVvUNHv3adFYBgY/";

// II SEMESTER
export const MEDIEVAL_INDIAN_HISTORY =
  "https://drive.google.com/file/d/1ffs26Befuv4xzRSHwjYXeEBR5YFKA1k0/";
export const INTRODUCTION_TO_POLITICAL_THEORY =
  "https://drive.google.com/file/d/1Hn7yCn8COWe0kjbzdBqQJirnFMRi93q7/";
export const REPORTING_AND_EDITING_FOR_MEDIA =
  "https://drive.google.com/file/d/1ENaNtOdkEEpX0ggRXSlbbdMY4BxUJHt7/";
export const SOCIOLOGICAL_FOUNDATIONS =
  "https://drive.google.com/file/d/1KiIw-o_NQ6D016WBWSauHjMpX2RX0qLL/";
export const BASIC_CONCEPTS_OF_HOSPITALITY_MANAGEMENT =
  "https://drive.google.com/file/d/1eXekXf19IzTEtkAT71xPxv6ca_GfdiVm/";
export const FILM_APPRECIATION =
  "https://drive.google.com/file/d/1nRx2P_VtR-3Y2GeROwErsnhfUd-UeP2c/";

// III SEMESTER
export const MODERN_INDIAN_HISTORY_I =
  "https://drive.google.com/file/d/11NDEhYDa1TO1Ma3itCs_XJEVqU9ts86L/";
export const INDIAN_GOVERNMENT_AND_POLITICS =
  "https://drive.google.com/file/d/1KefkfP2coH16MZJ2-eaYD4rdz3mJ1yLx/";
export const INTRODUCTION_TO_BROADCAST_MEDIA_TELEVISION =
  "https://drive.google.com/file/d/10T8Ld-MXt515FLGiMZU7KIZBwYDc0nea/";
export const INTRODUCTION_TO_SOCIAL_ANTHROPOLOGY =
  "https://drive.google.com/file/d/1MzyXUuEVPbpzEK79jvyR67COlH-sjvKV/";
export const GEOGRAPHY_OF_TOURISM =
  "https://drive.google.com/file/d/1VOq04OaLXZq4xzx12x4iNDxhb_dtOMxA/";

// IV SEMESTER
export const MODERN_INDIAN_HISTORY_II =
  "https://drive.google.com/file/d/1Fk_8ihCm8wy749irgsxLO3010tVJfYZt/";
export const INTRODUCTION_TO_HUMAN_RIGHTS =
  "https://drive.google.com/file/d/1ic_iHzkHKWlK26BUfVEyMVqi-Z5TNxiy/";
export const INTRODUCTION_FILM_MAKING =
  "https://drive.google.com/file/d/1NLZUZ62T3UuepCQ-__iCNl20Km5RtQ9m/";
export const CLASSICAL_SOCIOLOGICAL_THEORIES =
  "https://drive.google.com/file/d/1sedSUvFfXWuEm4wiBMVaR0uZutyh5jdk/";
export const TOURISM_MANAGEMENT =
  "https://drive.google.com/file/d/10dTb3MOvDHvY6Jt75W1fDIpEadd_Wa5j/";

// V SEMESTER
export const RESEARCH_METHODOLOGY =
  "https://drive.google.com/file/d/1KADmq31KPNTiIfQk6G44qQEn72w1QbLp/";
export const POLITICAL_AND_CULTURAL_HISTORY_OF_KARNATAKA_I =
  "https://docs.google.com/document/d/1j7govVW8Yoy5D-A-Cu0psTcF8aI2MczXTeQPz4PBK08/";
export const EUROPEAN_HISTORY =
  "https://drive.google.com/file/d/1IHGSK83YeTfTcMWU03x9q1T1pwa-49LE/";
export const INTERNATIONAL_RELATIONS =
  "https://drive.google.com/file/d/1qpkDEgG30RgPBquDrJKf5kO1GZAqGhVa/";
export const COMPARATIVE_GOVERNMENT_AND_POLITICS =
  "https://drive.google.com/file/d/1CRf6UgBfg0hHwFrTSysSAFHA7AQtBXev/";
export const BASICS_OF_PHOTOGRAPHY =
  "https://drive.google.com/file/d/1p3X4TuwdWIDUz5JlVUSyMGb0ETwnatMp/";
export const BASICS_OF_VIDEOGRAPHY =
  "https://drive.google.com/file/d/1GumoNGbnbbqyFXDUeyXR2z4Uv1NXgvSJ/";
export const INTRODUCTION_TO_SOCIOLOGICAL_RESEARCH =
  "https://drive.google.com/file/d/1RXiw-H8wuRuBm0Vjb5t2PeHsnk7ZePLv/";
export const AIRLINE_TICKETING_AND_GROUND_OPERATIONS =
  "https://drive.google.com/file/d/12dSQkNieOaog8ZOvHmKt9lknbgnvxxgA/";
export const CULTURAL_STUDIES =
  "https://drive.google.com/file/d/17cArdeG_JcFSInCafhi8heWpcO8zDdVG/";

// VI SEMESTER
export const POLITICAL_AND_CULTURAL_HISTORY_OF_KARNATAKA_II =
  "https://drive.google.com/file/d/18-Ss9GNZrhoneSh_mhtKnwKqGexlBqZ3/";
export const ASIAN_HISTORY =
  "https://drive.google.com/file/d/11PVraNxaZli0rIcrzE-_jymMadQA_qwI/";
export const PUBLIC_POLICY =
  "https://drive.google.com/file/d/13ZKDdhR6CqvYBg9fg3enJmPR-5mBSROk/";
export const MODERN_INDIAN_POLITICAL_THINKERS =
  "https://drive.google.com/file/d/1TRA_egi-UplKPwACOh15FKnsbF7kDWCn/";
export const ADVERTISING_AND_PUBLIC_RELATIONS =
  "https://drive.google.com/file/d/14NG660petsNXt2Skbkp04-L4kAnla6L-/";
export const ONLINE_JOURNALISM =
  "https://drive.google.com/file/d/1fOnt2OQYYdqnsxEYO4313k7Xfg9auobn/";
export const SOCIOLOGY_OF_INDIA =
  "https://drive.google.com/file/d/1KlQzW1qOgwAIJeRpHAZlLtkYhv_LcSt0/";
export const TRAVEL_AGENCY_AND_TOUR_OPERATIONS =
  "https://drive.google.com/file/d/1v7F5hgse1_6uMgb1WX8qk2Wemg97Pt9M/";

//SidewBar
export const HEI_APPLICATION =
  "https://drive.google.com/file/d/1YrSSJAd589Cum_jXy25wcO3zT_nb8DyR/";
export const IQAC_REPORTS =
  "https://drive.google.com/drive/folders/1KO4lWJE9kux_vBhTIyMCKMt4TN73auck/";

// ====================
// 🧩 MAP FOR DYNAMIC ACCESS
// ====================

export const pdfLinksMap = {
  // MBA
  MBA_MANAGERIAL_ECONOMICS: MANAGERIAL_ECONOMICS_LINK,
  MBA_ACCOUNTING_FOR_MANAGERS: ACCOUNTING_FOR_MANAGERS,
  MBA_DYNAMICS_OF_HUMAN_BEHAVIOR: DYNAMICS_OF_HUMAN_BEHAVIOR,
  MBA_DYNAMICS_OF_HUMAN_BEHAVIOR_VIDEO_1: DYNAMICS_OF_HUMAN_BEHAVIOR_VIDEO_1,
  MBA_DYNAMICS_OF_HUMAN_BEHAVIOR_VIDEO_2: DYNAMICS_OF_HUMAN_BEHAVIOR_VIDEO_2,
  MBA_INFORMATION_SYSTEM_AND_BUSINESS_ANALYTICS:
    INFORMATION_SYSTEM_AND_BUSINESS_ANALYTICS,
  MBA_MARKETING_MANAGEMENT: MARKETING_MANAGEMENT,
  MBA_MARKETING_MANAGEMENT_VIDEO_1: MARKETING_MANAGEMENT_VIDEO_1,
  MBA_MARKETING_MANAGEMENT_VIDEO_2: MARKETING_MANAGEMENT_VIDEO_2,
  MBA_BUSINESS_STATISTICS_WITH_R: BUSINESS_STATISTICS_WITH_R,
  MBA_HUMAN_RESOURCE_MANAGEMENT: HUMAN_RESOURCE_MANAGEMENT,
  MBA_HUMAN_RESOURCE_MANAGEMENT_VIDEO: HUMAN_RESOURCE_MANAGEMENT_VIDEO,
  MBA_INTERNATIONAL_BUSINESS_MANAGEMENT: INTERNATIONAL_BUSINESS_MANAGEMENT,
  MBA_BUSINESS_RESEARCH_METHODS: BUSINESS_RESEARCH_METHODS,
  MBA_FINANCIAL_MANAGEMENT: FINANCIAL_MANAGEMENT_MBA,
  MBA_OPERATIONS_RESEARCH_FOR_MANAGERS: OPERATIONS_RESEARCH_FOR_MANAGERS,
  MBA_STRATEGIC_ANALYSIS_AND_MANAGEMENT: STRATEGIC_ANALYSIS_AND_MANAGEMENT,
  MBA_OPERATIONS_MANAGEMENT: OPERATIONS_MANAGEMENT_MBA,
  MBA_LEGAL_ENVIRONMENT_OF_BUSINESS: LEGAL_ENVIRONMENT_OF_BUSINESS,
  MBA_LEADERSHIP_AND_CAPACITY_BUILDING: LEADERSHIP_AND_CAPACITY_BUILDING,
  MBA_TOTAL_QUALITY_MANAGEMENT: TOTAL_QUALITY_MANAGEMENT,
  MBA_TECHNOLOGY_MANAGEMENT: TECHNOLOGY_MANAGEMENT,
  MBA_DIGITAL_INNOVATION_AND_TRANSFORMATION_VIDEO:
    DIGITAL_INNOVATION_AND_TRANSFORMATION_VIDEO,
  MBA_DIGITAL_MARKETING_VIDEO: DIGITAL_MARKETING_VIDEO,
  MBA_EMPLOYEE_RELATIONSHIP_MANAGEMENT_VIDEO:
    EMPLOYEE_RELATIONSHIP_MANAGEMENT_VIDEO,
  MBA_COMPETENCY_MAPPING_VIDEO: COMPETENCY_MAPPING_VIDEO,
  MBA_STRATEGIC_ANALYSIS_AND_MANAGEMENT_VIDEO:
    STRATEGIC_ANALYSIS_AND_MANAGEMENT_VIDEO,
  MBA_LEGAL_ENVIRONMENT_OF_BUSINESS_VIDEO: LEGAL_ENVIRONMENT_OF_BUSINESS_VIDEO,

  // BBA
  BBA_FINANCIAL_ACCOUNTING: FINANCIAL_ACCOUNTING,
  BBA_BUSINESS_AND_TECHNOLOGY: BUSINESS_AND_TECHNOLOGY,
  BBA_BUSINESS_ECONOMICS: BUSINESS_ECONOMICS,
  BBA_BUSINESS_MATHEMATICS: BUSINESS_MATHEMATICS,
  BBA_PRINCIPLES_AND_PRACTICES_OF_MANAGEMENT:
    PRINCIPLES_AND_PRACTICES_OF_MANAGEMENT,
  BBA_MACRO_ECONOMICS: MACRO_ECONOMICS,
  BBA_CORPORATE_BUSINESS_LAW: CORPORATE_BUSINESS_LAW,
  BBA_BUSINESS_STATISTICS_WITH_ADVANCED_EXCEL:
    BUSINESS_STATISTICS_WITH_ADVANCED_EXCEL,
  BBA_CORPORATE_ACCOUNTING: CORPORATE_ACCOUNTING,
  BBA_HUMAN_RESOURCE_MANAGEMENT: HUMAN_RESOURCE_MANAGEMENT_BBA,
  BBA_OPERATIONS_MANAGEMENT: OPERATIONS_MANAGEMENT_BBA,
  BBA_MARKETING_MANAGEMENT: MARKETING_MANAGEMENT_BBA,
  BBA_FINANCIAL_MANAGEMENT: FINANCIAL_MANAGEMENT_BBA,
  BBA_BUSINESS_RESEARCH_METHODS: BUSINESS_RESEARCH_METHODS_BBA,
  BBA_ORGANISATIONAL_BEHAVIOR: ORGANISATIONAL_BEHAVIOR,
  BBA_COST_AND_MANAGEMENT_ACCOUNTING: COST_MANAGEMENT_ACCOUNTING,
  BBA_OPERATIONS_RESEARCH: OPERATIONS_RESEARCH,
  BBA_DIRECT_TAXATION: DIRECT_TAXATION,
  BBA_STRATEGIC_MANAGEMENT: STRATEGIC_MANAGEMENT,
  BBA_ENTREPRENEURSHIP_DEVELOPMENT: ENTREPRENEURSHIP_DEVELOPMENT,

  // BA
  ANCIENT_INDIAN_HISTORY,
  BASIC_CONCEPTS_IN_POLITICAL_SCIENCE,
  FOUNDATIONS_OF_COMMUNICATION,
  SOCIOLOGY_AN_INTRODUCTION,
  BASICS_OF_TOURISM,
  DIGITAL_MEDIA_LITERACY,
  COMPUTER_APPLICATION,
  MEDIEVAL_INDIAN_HISTORY,
  INTRODUCTION_TO_POLITICAL_THEORY,
  REPORTING_AND_EDITING_FOR_MEDIA,
  SOCIOLOGICAL_FOUNDATIONS,
  BASIC_CONCEPTS_OF_HOSPITALITY_MANAGEMENT,
  FILM_APPRECIATION,
  MODERN_INDIAN_HISTORY_I,
  INDIAN_GOVERNMENT_AND_POLITICS,
  INTRODUCTION_TO_BROADCAST_MEDIA_TELEVISION,
  INTRODUCTION_TO_SOCIAL_ANTHROPOLOGY,
  GEOGRAPHY_OF_TOURISM,
  MODERN_INDIAN_HISTORY_II,
  INTRODUCTION_TO_HUMAN_RIGHTS,
  INTRODUCTION_FILM_MAKING,
  CLASSICAL_SOCIOLOGICAL_THEORIES,
  TOURISM_MANAGEMENT,
  RESEARCH_METHODOLOGY,
  POLITICAL_AND_CULTURAL_HISTORY_OF_KARNATAKA_I,
  EUROPEAN_HISTORY,
  INTERNATIONAL_RELATIONS,
  COMPARATIVE_GOVERNMENT_AND_POLITICS,
  BASICS_OF_PHOTOGRAPHY,
  BASICS_OF_VIDEOGRAPHY,
  INTRODUCTION_TO_SOCIOLOGICAL_RESEARCH,
  AIRLINE_TICKETING_AND_GROUND_OPERATIONS,
  CULTURAL_STUDIES,
  POLITICAL_AND_CULTURAL_HISTORY_OF_KARNATAKA_II,
  ASIAN_HISTORY,
  PUBLIC_POLICY,
  MODERN_INDIAN_POLITICAL_THINKERS,
  ADVERTISING_AND_PUBLIC_RELATIONS,
  ONLINE_JOURNALISM,
  SOCIOLOGY_OF_INDIA,
  TRAVEL_AGENCY_AND_TOUR_OPERATIONS,
};
